export const PURCHASE_TYPE = {
	NEW: "subscription",
	SUBSCRIPTION: "subscription",
	RENEW: "renew",
	ADDON: "addon",
};

export const ERROR_STALE_CART = "STALE_CART";
export const isCurrentPlanPrice = (price, subscription) =>
	price.newPlanCode === subscription.planCode;
export const isNewPlanPrice = (price, subscription) => price.newPlanCode !== subscription.planCode;

export const FailedPaymentErrorCodes = ["EDECLINED_TRANSACTION", "EINVALID_TRANSACTION"];

export const isPaymentFailure = errorCode => FailedPaymentErrorCodes.includes(errorCode);
